export default [
  {
    path: '/card-to-be-prints',
    name: 'card-to-be-print',
    meta: { requiresAuth: true },
    component: () => import('@/pages/card-to-be-print/index.vue')
  }
]
